import React from 'react';
import { Grid, TextField, Typography, MenuItem, Divider, Paper, FormControlLabel, Checkbox } from '@material-ui/core';
import TablaSesiones from "../../components/TablaSesiones";
import { FORM_DICTIONARY } from '../schemas/formFields';

const campos_cognitivos = FORM_DICTIONARY.fichas.cognitiva;
const campos_generales = FORM_DICTIONARY.fichas.general;

const PREGUNTAS_SALUD = [
    { label: campos_cognitivos.problema_salud_especial.label, name: campos_cognitivos.problema_salud_especial.name, detalle: campos_cognitivos.problema_salud_especial.detalle },
    { label: campos_cognitivos.problema_vision.label, name: campos_cognitivos.problema_vision.name, detalle: campos_cognitivos.problema_vision.detalle },
    { label: campos_cognitivos.problema_audicion.label, name: campos_cognitivos.problema_audicion.name, detalle: campos_cognitivos.problema_audicion.detalle },
    { label: campos_cognitivos.alteracion_sueno.label, name: campos_cognitivos.alteracion_sueno.name, detalle: campos_cognitivos.alteracion_sueno.detalle },
    { label: campos_cognitivos.actualmente_esta_medicado.label, name: campos_cognitivos.actualmente_esta_medicado.name, detalle: campos_cognitivos.actualmente_esta_medicado.detalle },
    { label: campos_cognitivos.antecedentes_neurologicos.label, name: campos_cognitivos.antecedentes_neurologicos.name, detalle: campos_cognitivos.antecedentes_neurologicos.detalle },
    { label: campos_cognitivos.asistencia_terapia_neuropsicologica.label, name: campos_cognitivos.asistencia_terapia_neuropsicologica.name, detalle: campos_cognitivos.asistencia_terapia_neuropsicologica.detalle }
];


function PasoDatosYMotivo({ data, onChange }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeError = (field) => data?.[field]?.error || '';
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField 
                    fullWidth 
                    multiline 
                    rows={3} 
                    variant="outlined" 
                    label={campos_cognitivos.motivo_consulta_cognitiva.label}
                    name={campos_cognitivos.motivo_consulta_cognitiva.name}
                    value={safeValue(campos_cognitivos.motivo_consulta_cognitiva.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_cognitivos.motivo_consulta_cognitiva.name)}
                    helperText={safeError(campos_cognitivos.motivo_consulta_cognitiva.name)}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField 
                    fullWidth 
                    multiline 
                    rows={3} 
                    variant="outlined" 
                    label={campos_cognitivos.motivo_consulta_cognitiva_especifica.label}
                    name={campos_cognitivos.motivo_consulta_cognitiva_especifica.name}
                    value={safeValue(campos_cognitivos.motivo_consulta_cognitiva_especifica.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_cognitivos.motivo_consulta_cognitiva_especifica.name)}
                    helperText={safeError(campos_cognitivos.motivo_consulta_cognitiva_especifica.name)}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField 
                    fullWidth 
                    multiline 
                    rows={3} 
                    variant="outlined" 
                    label={campos_cognitivos.informacion_personal_familiar.label}
                    name={campos_cognitivos.informacion_personal_familiar.name}
                    value={safeValue(campos_cognitivos.informacion_personal_familiar.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_cognitivos.informacion_personal_familiar.name)}
                    helperText={safeError(campos_cognitivos.informacion_personal_familiar.name)}
                />
            </Grid>
        </Grid>
    );
}


function PasoSaludCognitiva({ data, onChange }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeError = (field) => (data?.[field]?.error || '');

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} md={4}>
                <TextField 
                    fullWidth 
                    label={campos_generales.nombre_eps.label}
                    name={campos_generales.nombre_eps.name}
                    value={safeValue(campos_generales.nombre_eps.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.nombre_eps.name)}
                    helperText={safeError(campos_generales.nombre_eps.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField 
                    fullWidth 
                    label={campos_generales.sisben.label}
                    name={campos_generales.sisben.name}
                    value={safeValue(campos_generales.sisben.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.sisben.name)}
                    helperText={safeError(campos_generales.sisben.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField 
                    fullWidth 
                    label={campos_generales.no_vinculado.label}
                    name={campos_generales.no_vinculado.name}
                    value={safeValue(campos_generales.no_vinculado.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.no_vinculado.name)}
                    helperText={safeError(campos_generales.no_vinculado.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField 
                    fullWidth 
                    label={campos_generales.grupo_priorizado.label}
                    name={campos_generales.grupo_priorizado.name}
                    value={safeValue(campos_generales.grupo_priorizado.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.grupo_priorizado.name)}
                    helperText={safeError(campos_generales.grupo_priorizado.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField 
                    fullWidth 
                    label={campos_generales.se_auto_reconoce_grupo_priorizado.label}
                    name={campos_generales.se_auto_reconoce_grupo_priorizado.name}
                    value={safeValue(campos_generales.se_auto_reconoce_grupo_priorizado.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                    helperText={safeError(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField 
                    fullWidth 
                    select 
                    label={campos_generales.certificado_grupo_priorizado.label}
                    name={campos_generales.certificado_grupo_priorizado.name}
                    value={safeValue(campos_generales.certificado_grupo_priorizado.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.certificado_grupo_priorizado.name)}
                    helperText={safeError(campos_generales.certificado_grupo_priorizado.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>


            {PREGUNTAS_SALUD.map((item) => (
                <React.Fragment key={item.name}>
                    <Grid item xs={12} md={6}>
                        <TextField 
                            fullWidth 
                            select 
                            label={item.label} 
                            name={item.name} 
                            value={safeValue(item.name)} 
                            onChange={onChange}
                            required
                            error={!!safeError(item.name)}
                            helperText={safeError(item.name)}
                        >
                            <MenuItem value="SI">Sí</MenuItem>
                            <MenuItem value="NO">No</MenuItem>
                        </TextField>
                    </Grid>
                    {data?.[item.name]?.valor === "SI" && (
                        <Grid item xs={12} md={6}>
                            <TextField 
                                fullWidth 
                                label="¿Cuál? / Tiempo" 
                                name={item.detalle} 
                                value={safeValue(item.detalle)} 
                                onChange={onChange}
                                required
                                error={!!safeError(item.detalle)}
                                helperText={safeError(item.detalle)}
                            />
                        </Grid>
                    )}
                </React.Fragment>
            ))}
        </Grid>
    );
}


function PasoAcademicoCognitivo({ data, onChange }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeError = (field) => (data?.[field]?.error || '');

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} md={6}>
                <TextField 
                    fullWidth 
                    select 
                    label={campos_cognitivos.calificacion_desempeno_cognitivo.label}
                    name={campos_cognitivos.calificacion_desempeno_cognitivo.name} 
                    value={safeValue(campos_cognitivos.calificacion_desempeno_cognitivo.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_cognitivos.calificacion_desempeno_cognitivo.name)}
                    helperText={safeError(campos_cognitivos.calificacion_desempeno_cognitivo.name)}
                >
                    <MenuItem value="EXCELENTE">Excelente</MenuItem>
                    <MenuItem value="SOBRESALIENTE">Sobresaliente</MenuItem>
                    <MenuItem value="REGULAR">Regular</MenuItem>
                    <MenuItem value="MALO">Malo</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField 
                    fullWidth 
                    label={campos_cognitivos.asignaturas_modalidad_actual.label}
                    name={campos_cognitivos.asignaturas_modalidad_actual.name} 
                    value={safeValue(campos_cognitivos.asignaturas_modalidad_actual.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_cognitivos.asignaturas_modalidad_actual.name)}
                    helperText={safeError(campos_cognitivos.asignaturas_modalidad_actual.name)}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    label={campos_cognitivos.influencia_desempeno.label}
                    name={campos_cognitivos.influencia_desempeno.name}
                    value={safeValue(campos_cognitivos.influencia_desempeno.name)}
                    required
                    error={!!safeError(campos_cognitivos.influencia_desempeno.name)}
                    helperText={safeError(campos_cognitivos.influencia_desempeno.name)}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    label={campos_cognitivos.metodo_estudio_planificacion.label}
                    name={campos_cognitivos.metodo_estudio_planificacion.name}
                    value={safeValue(campos_cognitivos.metodo_estudio_planificacion.name)}
                    required
                    error={!!safeError(campos_cognitivos.metodo_estudio_planificacion.name)}
                    helperText={safeError(campos_cognitivos.metodo_estudio_planificacion.name)}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        variant="outlined"
                        label={campos_cognitivos.aspectos_revelantes_anotaciones.label}
                        name={campos_cognitivos.aspectos_revelantes_anotaciones.name}
                        value={safeValue(campos_cognitivos.aspectos_revelantes_anotaciones.name)}
                        required
                        error={!!safeError(campos_cognitivos.aspectos_revelantes_anotaciones.name)}
                        helperText={safeError(campos_cognitivos.aspectos_revelantes_anotaciones.name)}
                        onChange={onChange}
                    />
            </Grid>
            <Grid item xs={12} md={12}></Grid>
        </Grid>
    );
}


function ControlSesiones({ data, onChangeSesion }) {

      const handleSesionesChange = (nuevasSesiones) => {
        onChangeSesion(nuevasSesiones);
    };


    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TablaSesiones
                sesiones={data.sesiones}
                onChange={handleSesionesChange}
                />
            </Grid>
        </Grid>
    );
}

/* =============================================
    EXPORTACIÓN DE PASOS
   ============================================= */
export const StepsAsesoriaCognitiva = [
    {
        label: 'Motivo de Asesoría',
        render: (props) => <PasoDatosYMotivo {...props} />
    },
    {
        label: 'Salud y Antecedentes',
        render: (props) => <PasoSaludCognitiva {...props} />
    },
    {
        label: 'Académico y Métodos',
        render: (props) => <PasoAcademicoCognitivo {...props} />
    },
    {
        label: 'Sesiones', 
        render: (props) => <ControlSesiones {...props} />
    },
];